import { OutputBlockData } from '@editorjs/editorjs';

import { extractCleanText } from './utils';

type NestedListItem = {
  content: string;
  items: NestedListItem[];
};

type FlatListItem = {
  content: string;
  level: number;
};

export const parseConsecutiveLists = (
  lists: Element[],
): OutputBlockData | null => {
  const flatItems: FlatListItem[] = [];
  let style: 'ordered' | 'unordered' = 'unordered';

  lists.forEach(list => {
    const tagName = list.tagName.toLowerCase();
    if (tagName === 'ol') style = 'ordered';

    const level = getListLevel(list);

    Array.from(list.children).forEach(child => {
      if (child.tagName.toLowerCase() === 'li') {
        const content = extractCleanText(child);
        flatItems.push({ content, level });
      }
    });
  });

  if (flatItems.length === 0) return null;

  const nestedItems = buildNestedStructure(flatItems);

  return {
    type: 'nestedList',
    data: {
      style,
      items: nestedItems,
    },
  };
};

const getListLevel = (listElement: Element): number => {
  const className = listElement.className;
  const match = className.match(/lst-kix_[\w-]+-(\d+)/);

  if (match) {
    return parseInt(match[1], 10);
  }

  return 0;
};

type StackItem = {
  item: NestedListItem;
  level: number;
};

const buildNestedStructure = (flatItems: FlatListItem[]): NestedListItem[] => {
  const result: NestedListItem[] = [];
  const stack: StackItem[] = [];

  flatItems.forEach(flatItem => {
    const newItem: NestedListItem = {
      content: flatItem.content,
      items: [],
    };

    while (stack.length > 0 && stack[stack.length - 1].level >= flatItem.level)
      stack.pop();

    if (stack.length === 0) result.push(newItem);
    else stack[stack.length - 1].item.items.push(newItem);

    stack.push({ item: newItem, level: flatItem.level });
  });

  return result;
};
